module.exports = __webpack_public_path__ + "static/media/circle-close.98809618.svg";